import util from '@bmp-vue/core/api/util'

const controller = 'CessaoBoleto'

export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post']), {
  GetAll:  function (dto) {
    return util.Axios.GetAll(controller, dto)
  },
  Historico: function (codigoCedenteCarteira) {
    return util.Axios.Get(`${controller}/Historico/${codigoCedenteCarteira}`)
  }
})